"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Command2 = _interopRequireDefault(require("./Command"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StartNewRoundCommand = /*#__PURE__*/function (_Command) {
  _inherits(StartNewRoundCommand, _Command);

  var _super = _createSuper(StartNewRoundCommand);

  function StartNewRoundCommand(_ref) {
    var _this;

    var store = _ref.store;

    _classCallCheck(this, StartNewRoundCommand);

    _this = _super.call(this, store, _constants.COMMANDS.START_NEW_ROUND);

    _defineProperty(_assertThisInitialized(_this), "openedCards", null);

    _this.openedCards = store.openedCards;
    store.updateSilence(true);
    return _this;
  }

  _createClass(StartNewRoundCommand, [{
    key: "apply",
    value: function apply() {
      if (this.isActive) {
        this.perform();
        this.moveCards();
      }

      return {
        type: this.name
      };
    }
  }, {
    key: "moveCards",
    value: function moveCards() {
      var _this2 = this;

      var card = this.openedCards[this.openedCards.length - 1];
      var el = document.querySelector("#".concat(card.id));

      el.ontransitionend = function () {
        _this2.openedCards.pop();

        _this2.store.updateOpenedCards();

        _this2.store.banker.discardPile.push(card);

        if (_this2.openedCards.length > 0) {
          return _this2.moveCards();
        }

        return _this2.complete();
      };

      el.classList.add('card--animation');
      el.style.transform = "translate3d(1000px, 0px, 0px)";
    }
  }]);

  return StartNewRoundCommand;
}(_Command2["default"]);

exports["default"] = StartNewRoundCommand;